
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`La Suisse dénombre plus de 600'000 cas confirmés de Covid-19 depuis le début de la pandémie. Toutefois, les détails des contaminations par commune manquaient jusqu'ici. Les chiffres récemment publiés par l'Office fédéral de la santé publique (OFSP) permettent pour la première fois cette lecture géographique de détail pour chacune des trois vagues qui ont frappé le pays. Les données montrent le nombre de nouveaux cas quotidiens de Covid-19 confirmés par commune, standardisé pour 10'000 habitants.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;